<template>
  <div class="container greyPage  mySignContent">
    <van-nav-bar title="我的报名" left-text fixed left-arrow @click-left="onClickLeft" />
    <van-tabs v-model="active" swipeable class="homeTab greyPage tabContent" style="margin-top: 6px">
      <van-tab title="未开始">
        <sign-ready></sign-ready>
      </van-tab>
      <van-tab title="进行中">
        <sign-ing></sign-ing>
      </van-tab>
      <van-tab title="已完成">
        <sign-done></sign-done>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import SignReady from './components/signReady.vue';
import SignIng from './components/signIng.vue';
import SignDone from './components/signDone.vue';
export default {
  components: { SignReady, SignIng, SignDone },
  data() {
    return {
      active: '未开始',
    }
  },
  created() {

  },
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },
  },
};
</script>

<style lang='less'>
.mySignContent {
  bottom:0;
  .van-tab--active .van-tab__text {
    font-size: 16px;
  }
  .van-tabs__line {
    bottom: 3px;
  }
  .van-tabs__nav,.tabContent .van-tabs__content{background: transparent;}
  .pageList .pageListItem{background: #fff;}
}
</style>